import { ItemCategoryBase } from './base/item-category-base';

export class ItemCategory extends ItemCategoryBase { }